class WhRuntimeException extends Error {
    constructor(message) {
        super();
        this.message = "系统异常，请稍后再试";
    }
}

export default WhRuntimeException


// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhRuntimeException.js